var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading d-flex ai-center jc-center"},[_c('div',{staticClass:"wrapper"},[_c('Spinner',{attrs:{"size":_vm.size}})],1),(_vm.label)?_c('span',{staticClass:"ml-10"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('b',{staticClass:"elipses"},[_vm._v("...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }